import { render, staticRenderFns } from "./testquestion-manage.vue?vue&type=template&id=2fe6ca00&scoped=true"
import script from "./testquestion-manage.vue?vue&type=script&lang=js"
export * from "./testquestion-manage.vue?vue&type=script&lang=js"
import style0 from "./testquestion-manage.vue?vue&type=style&index=0&id=2fe6ca00&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6ca00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe6ca00')) {
      api.createRecord('2fe6ca00', component.options)
    } else {
      api.reload('2fe6ca00', component.options)
    }
    module.hot.accept("./testquestion-manage.vue?vue&type=template&id=2fe6ca00&scoped=true", function () {
      api.rerender('2fe6ca00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/testquestion-manage.vue"
export default component.exports